import { useLayoutEffect, useRef, useState } from 'react';

export const useIsComponentCropped = content => {
  const componentRef = useRef();
  const [isCropped, setIsCropped] = useState(false);

  useLayoutEffect(() => {
    const el = componentRef.current;
    if (el) setIsCropped(el.scrollWidth > el.clientWidth);
  }, [content]);

  return { isCropped, componentRef };
};
